var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "scrollContainer", staticClass: "device-info" },
    [
      _c("h2", [
        _vm._v("\n    Info\n    "),
        _c(
          "span",
          { staticClass: "env-badge", class: _vm.environment.toLowerCase() },
          [_vm._v(_vm._s(_vm.environment))]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "keybar keybar--top" },
        [
          _c("span", { staticClass: "keybar-title" }, [_vm._v("Farbtasten")]),
          _vm._v(" "),
          _vm._l(_vm.keyLegend, function(entry) {
            return _c(
              "span",
              { key: entry.label, staticClass: "keybar-item" },
              [
                entry.dot
                  ? _c("i", { staticClass: "dot", class: entry.dot })
                  : _vm._e(),
                _vm._v(_vm._s(entry.label) + "\n    ")
              ]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.loading
        ? [_vm._v("\n    Loading...\n  ")]
        : [
            _c("div", { staticClass: "legend" }, [
              _vm._v("\n      Angezeigt: "),
              _c("strong", [_vm._v("Live-Wert vom Gerät")]),
              _c("span", { staticClass: "current" }, [
                _vm._v(" (DB-Wert, falls abweichend)")
              ]),
              _c("span", { staticClass: "missing" }, [_vm._v(" (DB: leer)")]),
              _vm._v(" "),
              _vm.staleCount
                ? _c("span", { staticClass: "count" }, [
                    _vm._v(" — " + _vm._s(_vm.staleCount) + " abweichend")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.missingCount
                ? _c("span", { staticClass: "missing" }, [
                    _vm._v(" — " + _vm._s(_vm.missingCount) + " in der DB leer")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("span", { staticClass: "readable" }, [
                _vm._v(
                  "DB-Stand: " +
                    _vm._s(
                      _vm.dbFromApi
                        ? "direkt aus der API gelesen"
                        : "aus dem Store (API nicht erreichbar)"
                    )
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "info-columns" },
              _vm._l(_vm.columns, function(col, ci) {
                return _c("div", { key: ci, staticClass: "info-col" }, [
                  _c(
                    "table",
                    _vm._l(col, function(row) {
                      return _c(
                        "tr",
                        { key: row.key, staticClass: "info-item" },
                        [
                          _c("td", { staticClass: "key" }, [
                            _vm._v(_vm._s(row.key))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "value" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.formatValue(row.value))
                            ),
                            row.current !== undefined
                              ? _c("span", { staticClass: "current" }, [
                                  _vm._v(
                                    " (" +
                                      _vm._s(_vm.formatValue(row.current)) +
                                      ")"
                                  )
                                ])
                              : row.dbMissing
                              ? _c("span", { staticClass: "missing" }, [
                                  _vm._v(" (DB: leer)")
                                ])
                              : _vm._e(),
                            row.readable
                              ? _c("span", { staticClass: "readable" }, [
                                  _vm._v(" (" + _vm._s(row.readable) + ")")
                                ])
                              : _vm._e()
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              }),
              0
            ),
            _vm._v(" "),
            _vm.webosRows.length
              ? _c("div", { staticClass: "diagnostics" }, [
                  _c("h3", [
                    _vm._v(
                      "WebOS-Version (Quelle: " + _vm._s(_vm.webosSource) + ")"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "table",
                    _vm._l(_vm.webosRows, function(row) {
                      return _c(
                        "tr",
                        { key: row.key, staticClass: "info-item" },
                        [
                          _c("td", { staticClass: "key" }, [
                            _vm._v(_vm._s(row.key))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "value" }, [
                            _vm._v(_vm._s(row.value))
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.castRows.length
              ? _c("div", { staticClass: "diagnostics" }, [
                  _c("h3", [_vm._v("Cast-Diagnose")]),
                  _vm._v(" "),
                  _c(
                    "table",
                    _vm._l(_vm.castRows, function(row) {
                      return _c(
                        "tr",
                        { key: row.key, staticClass: "info-item" },
                        [
                          _c("td", { staticClass: "key" }, [
                            _vm._v(_vm._s(row.key))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "value" }, [
                            _vm._v(_vm._s(row.value))
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.softApProbeRows.length
              ? _c("div", { staticClass: "diagnostics" }, [
                  _c("h3", [
                    _vm._v(
                      "SoftAP-Funktionen am Gerät (" +
                        _vm._s(_vm.softApProbeRows.length) +
                        ")"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "table",
                    _vm._l(_vm.softApProbeRows, function(row) {
                      return _c(
                        "tr",
                        { key: row.key, staticClass: "info-item" },
                        [
                          _c("td", { staticClass: "key" }, [
                            _vm._v(_vm._s(row.key))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "value" }, [
                            _vm._v(_vm._s(row.value))
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.castPropertyRows.length
              ? _c("div", { staticClass: "diagnostics" }, [
                  _c("h3", [
                    _vm._v(
                      "Cast-Properties am Gerät (" +
                        _vm._s(_vm.castPropertyKnown) +
                        " von " +
                        _vm._s(_vm.castPropertyRows.length) +
                        " bekannt)"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "table",
                    _vm._l(_vm.castPropertyRows, function(row) {
                      return _c(
                        "tr",
                        { key: row.key, staticClass: "info-item" },
                        [
                          _c("td", { staticClass: "key" }, [
                            _vm._v(_vm._s(row.key))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "value" }, [
                            _vm._v(_vm._s(row.value))
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.deviceSettingRows.length
              ? _c("div", { staticClass: "diagnostics" }, [
                  _c("h3", [
                    _vm._v(
                      "\n        Geräteinterne Einstellungen (" +
                        _vm._s(_vm.deviceSettingsSupported) +
                        " von\n        " +
                        _vm._s(_vm.deviceSettingsTotal) +
                        " unterstützt)\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "table",
                    _vm._l(_vm.deviceSettingRows, function(row) {
                      return _c(
                        "tr",
                        { key: row.key, staticClass: "info-item" },
                        [
                          _c("td", { staticClass: "key" }, [
                            _vm._v(_vm._s(row.key))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "value" }, [
                            _vm._v(_vm._s(row.value))
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.storageProbeRows.length
              ? _c("div", { staticClass: "diagnostics" }, [
                  _c("h3", [_vm._v("Speicher und Dateien am Gerät")]),
                  _vm._v(" "),
                  _c(
                    "table",
                    _vm._l(_vm.storageProbeRows, function(row) {
                      return _c(
                        "tr",
                        { key: row.key, staticClass: "info-item" },
                        [
                          _c("td", { staticClass: "key" }, [
                            _vm._v(_vm._s(row.key))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "value" }, [
                            _vm._v(_vm._s(row.value))
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.deviceSettingApiRows.length
              ? _c("div", { staticClass: "diagnostics" }, [
                  _c("h3", [_vm._v("Einstellungs-API des Geräts")]),
                  _vm._v(" "),
                  _c(
                    "table",
                    _vm._l(_vm.deviceSettingApiRows, function(row) {
                      return _c(
                        "tr",
                        { key: row.key, staticClass: "info-item" },
                        [
                          _c("td", { staticClass: "key" }, [
                            _vm._v(_vm._s(row.key))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "value" }, [
                            _vm._v(_vm._s(row.value))
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.storageSections, function(section) {
              return _c(
                "div",
                { key: section.title, staticClass: "diagnostics" },
                [
                  _c("h3", [_vm._v(_vm._s(section.title))]),
                  _vm._v(" "),
                  _c(
                    "table",
                    _vm._l(section.rows, function(row) {
                      return _c(
                        "tr",
                        { key: row.key, staticClass: "info-item" },
                        [
                          _c("td", { staticClass: "key" }, [
                            _vm._v(_vm._s(row.key))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "value" }, [
                            _vm._v(_vm._s(row.value))
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
            }),
            _vm._v(" "),
            _vm.preloadedAppRows.length
              ? _c("div", { staticClass: "diagnostics" }, [
                  _c("h3", [
                    _vm._v(
                      "Preloaded-Apps (" +
                        _vm._s(_vm.preloadedAppRows.length) +
                        ")"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "table",
                    _vm._l(_vm.preloadedAppRows, function(row) {
                      return _c(
                        "tr",
                        { key: row.key, staticClass: "info-item" },
                        [
                          _c("td", { staticClass: "key" }, [
                            _vm._v(_vm._s(row.key))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "value" }, [
                            _vm._v(_vm._s(row.value))
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.installedApps.length
              ? _c("div", { staticClass: "installed-apps" }, [
                  _c("h3", [
                    _vm._v(
                      "Cast-relevante Apps (" +
                        _vm._s(_vm.castApps.length) +
                        " von " +
                        _vm._s(_vm.installedApps.length) +
                        " im Katalog)"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "table",
                    [
                      _vm._l(_vm.castApps, function(app) {
                        return _c(
                          "tr",
                          { key: app.id, staticClass: "info-item" },
                          [
                            _c("td", { staticClass: "key" }, [
                              _vm._v(_vm._s(app.label))
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "value" }, [
                              _vm._v("\n            " + _vm._s(app.id)),
                              app.version
                                ? _c("span", { staticClass: "current" }, [
                                    _vm._v(" — v" + _vm._s(app.version))
                                  ])
                                : _vm._e(),
                              !app.installed
                                ? _c("span", { staticClass: "current" }, [
                                    _vm._v(" — nicht installiert (valid=false)")
                                  ])
                                : _vm._e()
                            ])
                          ]
                        )
                      }),
                      _vm._v(" "),
                      !_vm.castApps.length
                        ? _c("tr", [
                            _c(
                              "td",
                              { staticClass: "value", attrs: { colspan: "2" } },
                              [_vm._v("Keine Cast-relevanten Apps gefunden")]
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                ])
              : _vm._e()
          ],
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "keybar" },
        _vm._l(_vm.keyLegend, function(entry) {
          return _c("span", { key: entry.label, staticClass: "keybar-item" }, [
            entry.dot
              ? _c("i", { staticClass: "dot", class: entry.dot })
              : _vm._e(),
            _vm._v(_vm._s(entry.label) + "\n    ")
          ])
        }),
        0
      ),
      _vm._v(" "),
      _vm.dialog
        ? _c("div", { staticClass: "dialog" }, [
            _c("div", { staticClass: "dialog-box" }, [
              _c("div", { staticClass: "dialog-title" }, [
                _vm._v(_vm._s(_vm.dialogTitle))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dialog-text" }, [
                _vm._v(_vm._s(_vm.dialogText))
              ]),
              _vm._v(" "),
              _vm.clearReport
                ? _c("div", { staticClass: "dialog-report" }, [
                    _vm._v(_vm._s(_vm.clearReport))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-buttons" },
                _vm._l(_vm.dialogButtons, function(button, index) {
                  return _c(
                    "div",
                    {
                      key: button.action,
                      staticClass: "dialog-button",
                      class: {
                        "dialog-button--active": index === _vm.dialogIndex
                      }
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(button.label) + "\n        "
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fbb2475c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbb2475c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Info.vue
// module id = null
// module chunks = 